import React from 'react';
import { Link as RouteLink, LinkProps as RouteLinkProps } from 'react-router-dom';
import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material';

type CombinedLinkProps = RouteLinkProps & MuiLinkProps;

const Link: React.FC<CombinedLinkProps> = ({
  children,
  to,
  ...props
}) => {
  return (
    <MuiLink component={RouteLink} to={to} {...props}>
      {children}
    </MuiLink>
  );
};

export default Link;
